import React, { FC } from 'react';
import Logo from './Logo.svg';
import s from './Header.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { Avatar } from '@wix/design-system';
import { useInitialState } from '../../contexts/InitialStateContext';
import { headerDataHooks } from './Header.dataHooks';
import { JOIN_WAIT_LIST_URL, STUDIO_LANDING_URL } from '../../config';
import { useBiLogger } from '../../contexts/BILoggerContext';

export const Header: FC = () => {
  const { t } = useTranslation();
  const { userData } = useInitialState();
  const { reportJoinTheWaitlistClick } = useBiLogger();
  const withJoinWaitList =
    !userData.isLoggedIn || !userData.profile.isStudioAccount;

  return (
    <>
      <header className={s.header}>
        <a href={STUDIO_LANDING_URL} className={s.logoContainer}>
          <Logo />
        </a>
        <div className={s.actionPanel}>
          {userData.isLoggedIn && !withJoinWaitList ? (
            <div
              data-hook={headerDataHooks.userMenu()}
              className={s.userContainer}
            >
              <div className={s.userIcon}>
                <Avatar
                  imgProps={{ src: userData.profile.image?.imageUrl }}
                  size="size30"
                />
              </div>
              <div className={s.userName}>
                {userData.profile.name?.first} {userData.profile.name?.last}
              </div>
            </div>
          ) : null}

          {withJoinWaitList && (
            <a
              data-hook={headerDataHooks.joinWaitlist()}
              className={s.joinWaitListButton}
              href={JOIN_WAIT_LIST_URL}
              target="_blank"
              onClick={() => reportJoinTheWaitlistClick(true)}
              rel="noreferrer"
            >
              {t('app.header.joinWaitList')}
            </a>
          )}
        </div>
      </header>
    </>
  );
};
